import {
    SITEIDS_FAILURE,
    SITEIDS_LOADING,
    SITEIDS_SUCCESS,
    CATEGORIES_FAILURE,
    CATEGORIES_SUCCESS,
    CATEGORIES_LOADING,
    ADMIN_SITES_FAILURE,
    ADMIN_SITES_LOADING,
    ADMIN_SITES_SUCCESS,
    SET_MOBILE,
} from 'redux/reduxConstants';

export function siteIdsLoading() {
    return { type: SITEIDS_LOADING };
}

export function siteIdsSuccess(siteIds) {
    return { type: SITEIDS_SUCCESS, siteIds };
}

export function siteIdsFailure(error) {
    return { type: SITEIDS_FAILURE, error };
}

export function adminSitesLoading() {
    return { type: ADMIN_SITES_LOADING };
}

export function adminSitesSuccess(adminSiteIds) {
    return { type: ADMIN_SITES_SUCCESS, adminSiteIds };
}

export function adminSitesFailure(error) {
    return { type: ADMIN_SITES_FAILURE, error };
}

export function categoriesLoading() {
    return { type: CATEGORIES_LOADING };
}

export function categoriesSuccess(categories) {
    return { type: CATEGORIES_SUCCESS, categories };
}

export function categoriesFailure(error) {
    return { type: CATEGORIES_FAILURE, error };
}

export function setMobile(showMobile) {
    return { type: SET_MOBILE, showMobile };
}
